import React from 'react';

export default function Footer(){
	return(
		<footer>
    		<p>&copy; 2026 BridgingSkilled. All rights reserved.</p>
 		 </footer>
	)
}